import type { ElementType } from 'react';

import { useResponsiveProp } from '@hrworks/sui-shared/hooks';

import { S } from './Text.styles';
import type { TextProps } from './Text.types';

export const Text = <C extends ElementType = 'span'>({
  children,
  component,
  typography,
  variant = 'default',
  hover,
  color,
  width,
  underlined,
  italic,
  textAlign,
  overflowBehaviour = 'break',
  lineClamp,
  ...otherProps
}: TextProps<C>) => {
  const Element = component || (otherProps.href ? 'a' : 'span');

  const _typography = useResponsiveProp(typography);

  return (
    <S.Text
      as={Element}
      $variant={variant}
      $hover={hover}
      $width={width}
      $color={color}
      $underlined={underlined}
      $italic={italic}
      $textAlign={textAlign}
      $typography={_typography}
      $href={otherProps.href}
      $overflowBehaviour={overflowBehaviour}
      $lineClamp={lineClamp}
      {...otherProps}
    >
      {children}
    </S.Text>
  );
};
